// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_breakdown_mode_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { DemandBreakdownMode, DemandBreakdownModeRow } from "./demand_breakdown_mode_model_pb";
import { file_bffuser_v1_demand_breakdown_mode_model } from "./demand_breakdown_mode_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_breakdown_mode_service.proto.
 */
export const file_bffuser_v1_demand_breakdown_mode_service: GenFile = /*@__PURE__*/
  fileDesc("Ci5iZmZ1c2VyL3YxL2RlbWFuZF9icmVha2Rvd25fbW9kZV9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIiEKH0xpc3REZW1hbmRCcmVha2Rvd25Nb2Rlc1JlcXVlc3QibQogTGlzdERlbWFuZEJyZWFrZG93bk1vZGVzUmVzcG9uc2USFwoPZmVhdHVyZV9lbmFibGVkGAEgASgIEjAKBHJvd3MYAiADKAsyIi5iZmZ1c2VyLnYxLkRlbWFuZEJyZWFrZG93bk1vZGVSb3ciqQIKHlNhdmVEZW1hbmRCcmVha2Rvd25Nb2RlUmVxdWVzdBI0CglhcmVhX2NvZGUYAiABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIKukgHggEEEAEgABIeCg1yZXRhaWxlcl9jb2RlGAMgASgJQge6SARyAhABEjkKBG1vZGUYBCABKA4yHy5iZmZ1c2VyLnYxLkRlbWFuZEJyZWFrZG93bk1vZGVCCrpIB4IBBBABIAASEQoEbm90ZRgFIAEoCUgAiAEBEjwKE2V4cGVjdGVkX3VwZGF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQFCBwoFX25vdGVCFgoUX2V4cGVjdGVkX3VwZGF0ZWRfYXRKBAgBEAIiUQofU2F2ZURlbWFuZEJyZWFrZG93bk1vZGVSZXNwb25zZRIuCgp1cGRhdGVkX2F0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCLUAQogRGVsZXRlRGVtYW5kQnJlYWtkb3duTW9kZVJlcXVlc3QSNAoJYXJlYV9jb2RlGAIgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCCrpIB4IBBBABIAASHgoNcmV0YWlsZXJfY29kZRgDIAEoCUIHukgEcgIQARI8ChNleHBlY3RlZF91cGRhdGVkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBQhYKFF9leHBlY3RlZF91cGRhdGVkX2F0SgQIARACIiMKIURlbGV0ZURlbWFuZEJyZWFrZG93bk1vZGVSZXNwb25zZTKHAwoaRGVtYW5kQnJlYWtkb3duTW9kZVNlcnZpY2USdwoYTGlzdERlbWFuZEJyZWFrZG93bk1vZGVzEisuYmZmdXNlci52MS5MaXN0RGVtYW5kQnJlYWtkb3duTW9kZXNSZXF1ZXN0GiwuYmZmdXNlci52MS5MaXN0RGVtYW5kQnJlYWtkb3duTW9kZXNSZXNwb25zZSIAEnQKF1NhdmVEZW1hbmRCcmVha2Rvd25Nb2RlEiouYmZmdXNlci52MS5TYXZlRGVtYW5kQnJlYWtkb3duTW9kZVJlcXVlc3QaKy5iZmZ1c2VyLnYxLlNhdmVEZW1hbmRCcmVha2Rvd25Nb2RlUmVzcG9uc2UiABJ6ChlEZWxldGVEZW1hbmRCcmVha2Rvd25Nb2RlEiwuYmZmdXNlci52MS5EZWxldGVEZW1hbmRCcmVha2Rvd25Nb2RlUmVxdWVzdBotLmJmZnVzZXIudjEuRGVsZXRlRGVtYW5kQnJlYWtkb3duTW9kZVJlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_bffuser_v1_demand_breakdown_mode_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * @generated from message bffuser.v1.ListDemandBreakdownModesRequest
 */
export type ListDemandBreakdownModesRequest = Message<"bffuser.v1.ListDemandBreakdownModesRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListDemandBreakdownModesRequest.
 * Use `create(ListDemandBreakdownModesRequestSchema)` to create a new message.
 */
export const ListDemandBreakdownModesRequestSchema: GenMessage<ListDemandBreakdownModesRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_breakdown_mode_service, 0);

/**
 * @generated from message bffuser.v1.ListDemandBreakdownModesResponse
 */
export type ListDemandBreakdownModesResponse = Message<"bffuser.v1.ListDemandBreakdownModesResponse"> & {
  /**
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * @generated from field: repeated bffuser.v1.DemandBreakdownModeRow rows = 2;
   */
  rows: DemandBreakdownModeRow[];
};

/**
 * Describes the message bffuser.v1.ListDemandBreakdownModesResponse.
 * Use `create(ListDemandBreakdownModesResponseSchema)` to create a new message.
 */
export const ListDemandBreakdownModesResponseSchema: GenMessage<ListDemandBreakdownModesResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_breakdown_mode_service, 1);

/**
 * @generated from message bffuser.v1.SaveDemandBreakdownModeRequest
 */
export type SaveDemandBreakdownModeRequest = Message<"bffuser.v1.SaveDemandBreakdownModeRequest"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string retailer_code = 3;
   */
  retailerCode: string;

  /**
   * @generated from field: bffuser.v1.DemandBreakdownMode mode = 4;
   */
  mode: DemandBreakdownMode;

  /**
   * Surrounding whitespace is removed; empty means no note.
   *
   * @generated from field: optional string note = 5;
   */
  note?: string;

  /**
   * Optimistic-lock baseline: the row's updated_at from the list. Absent
   * when the pair has no setting.
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 6;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SaveDemandBreakdownModeRequest.
 * Use `create(SaveDemandBreakdownModeRequestSchema)` to create a new message.
 */
export const SaveDemandBreakdownModeRequestSchema: GenMessage<SaveDemandBreakdownModeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_breakdown_mode_service, 2);

/**
 * @generated from message bffuser.v1.SaveDemandBreakdownModeResponse
 */
export type SaveDemandBreakdownModeResponse = Message<"bffuser.v1.SaveDemandBreakdownModeResponse"> & {
  /**
   * The baseline for the next change of the pair.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SaveDemandBreakdownModeResponse.
 * Use `create(SaveDemandBreakdownModeResponseSchema)` to create a new message.
 */
export const SaveDemandBreakdownModeResponseSchema: GenMessage<SaveDemandBreakdownModeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_breakdown_mode_service, 3);

/**
 * @generated from message bffuser.v1.DeleteDemandBreakdownModeRequest
 */
export type DeleteDemandBreakdownModeRequest = Message<"bffuser.v1.DeleteDemandBreakdownModeRequest"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string retailer_code = 3;
   */
  retailerCode: string;

  /**
   * Optimistic-lock baseline: the row's updated_at from the list.
   *
   * @generated from field: optional google.protobuf.Timestamp expected_updated_at = 4;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteDemandBreakdownModeRequest.
 * Use `create(DeleteDemandBreakdownModeRequestSchema)` to create a new message.
 */
export const DeleteDemandBreakdownModeRequestSchema: GenMessage<DeleteDemandBreakdownModeRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_breakdown_mode_service, 4);

/**
 * @generated from message bffuser.v1.DeleteDemandBreakdownModeResponse
 */
export type DeleteDemandBreakdownModeResponse = Message<"bffuser.v1.DeleteDemandBreakdownModeResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteDemandBreakdownModeResponse.
 * Use `create(DeleteDemandBreakdownModeResponseSchema)` to create a new message.
 */
export const DeleteDemandBreakdownModeResponseSchema: GenMessage<DeleteDemandBreakdownModeResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_breakdown_mode_service, 5);

/**
 * DemandBreakdownModeService fronts the 想定モード tab of the 需要想定設定
 * screen. The BFF relays each RPC 1:1 to the backend
 * internalapi DemandBreakdownModeService; organization_id and the updater are
 * resolved from the eauth session. Every user who can sign in may edit (no
 * role gating). While the organization's feature flag is off the list has
 * feature_enabled=false and no row, and save / delete return
 * FAILED_PRECONDITION without writing.
 *
 * @generated from service bffuser.v1.DemandBreakdownModeService
 */
export const DemandBreakdownModeService: GenService<{
  /**
   * ListDemandBreakdownModes returns the organization's whole list, area
   * ascending; within an area the demand-forecast scope's retailers in scope
   * order, then out-of-scope retailers that still have a setting.
   *
   * @generated from rpc bffuser.v1.DemandBreakdownModeService.ListDemandBreakdownModes
   */
  listDemandBreakdownModes: {
    methodKind: "unary";
    input: typeof ListDemandBreakdownModesRequestSchema;
    output: typeof ListDemandBreakdownModesResponseSchema;
  },
  /**
   * SaveDemandBreakdownMode replaces the (area, retailer) setting with one
   * that is always in effect. FAILED_PRECONDITION with a
   * DemandBreakdownSaveErrorReason when the save is not allowed, ABORTED when
   * another user changed the setting first, INVALID_ARGUMENT for a note that
   * is too long.
   *
   * @generated from rpc bffuser.v1.DemandBreakdownModeService.SaveDemandBreakdownMode
   */
  saveDemandBreakdownMode: {
    methodKind: "unary";
    input: typeof SaveDemandBreakdownModeRequestSchema;
    output: typeof SaveDemandBreakdownModeResponseSchema;
  },
  /**
   * DeleteDemandBreakdownMode removes the (area, retailer) setting, so the
   * 一括想定 default applies again. ABORTED when another user changed or
   * deleted the setting first.
   *
   * @generated from rpc bffuser.v1.DemandBreakdownModeService.DeleteDemandBreakdownMode
   */
  deleteDemandBreakdownMode: {
    methodKind: "unary";
    input: typeof DeleteDemandBreakdownModeRequestSchema;
    output: typeof DeleteDemandBreakdownModeResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_demand_breakdown_mode_service, 0);

